import React, { useEffect } from "react";
import TherapyRoomCard from "../TherapyRooms/TherapyRoomCard";
import Navbar from "../Navbar";
import Footer from "../Footer";
import beach from "../../assets/images/beach.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Env from '../../runtimeEnv';

// For now, using hardcoded IDs. Later, this list can be fetched from DynamoDB via API.
// const allowedUserIds = ["34AB56CD","ST56UV78", "90QR12ST", "34UV56WX", "5CAFBPYH", "78YZ90AB", "UFTBN1O1", "MN34OP56", "OP12QR34", "KL78MN90", "2D9BFUVY", "UV12WX34"];

function DemoPage({
  setCurrentNickname,
  currentNickname,
  handleLogout,
  setFormType,
  PlutonicuserID,
}) {
  const navigate = useNavigate();

  //   useEffect(() => {
  //     const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");
  //     console.log("[DemoPage] Current User ID:", userId);

  //     if (!allowedUserIds.includes(userId)) {
  //       console.warn(`[DemoPage] User ID (${userId}) is not allowed to access this page.`);
  //       navigate("/therapy-rooms"); // Redirect unauthorized users
  //     }
  //   }, [PlutonicuserID, navigate]);

  useEffect(() => {
    const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");
    // console.log("[DemoPage] Current User ID:", userId);

    const checkDemoAccess = async () => {
      try {
        const response = await axios.get(
          `${Env.REACT_APP_PYTHON_API_URL}/api/GetMeetings/${userId}`,
          {
            headers: {
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
              Expires: "0",
            },
            params: { t: new Date().getTime() }, // Cache-busting
          }
        );

        const meetings = response.data;

        const hasDemoAccess = meetings.some(
          (meeting) =>
            meeting.PlutonicuserID.includes(userId) &&
            meeting.demoaccess === true
        );

        if (!hasDemoAccess) {
          // console.warn(
          //   "[DemoPage] No demo-access-eligible meetings found for user."
          // );
          navigate("/therapy-rooms");
        } else {
          console.log(" User has demo access.");
        }
      } catch (error) {
        // console.error("[DemoPage] Error fetching meetings:", error);
        navigate("/therapy-rooms"); // fallback redirect if there's an error
      }
    };

    if (userId) {
      checkDemoAccess();
    } else {
      // console.warn("[DemoPage] No user ID found. Redirecting.");
      navigate("/therapy-rooms");
    }
  }, [PlutonicuserID, navigate]);

  const beachRoom = {
    id: "demo-beach-therapy",
    title: "Plutonic Therapy Beach Office",
    description:
      "Consider having a session with your licensed mental health professional inside the office or in the cabana. Take in the sounds of the ocean waves and the sunset as you reduce stress.",
    image: beach,
    style: "Modern Design",
    accessibility: "PC Web Browser | Chrome, Edge",
    available: true,
    sessionStartTimeEST: "Always Available",
    online: false,
  };

  const handleEnterClick = (roomType) => {
    const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");
    if (!userId) {
      alert("User ID is missing. Please log in again.");
      return;
    }
  

  
    const testMeetingID = `${roomType}-${userId}`;
    sessionStorage.setItem("meetingID", testMeetingID);
    sessionStorage.setItem("userId", userId);
  
    // console.log("[DemoPage] sessionStorage - meetingID:", testMeetingID);
    // console.log("[DemoPage] sessionStorage - userId:", userId);
  
    navigate(`/unity-room/beach`);
  };
  

  return (
    <div>
      <Navbar
        setCurrentNickname={(nickname) => {
          setCurrentNickname(nickname);
          localStorage.setItem("currentNickname", nickname);
        }}
        currentNickname={currentNickname}
        handleLogout={handleLogout}
        setFormType={setFormType}
        showButtons={true}
        PlutonicuserID={
          PlutonicuserID || localStorage.getItem("PlutonicuserID")
        }
      />
      <div
        className="flex flex-col items-center min-h-screen pt-24 pb-16 px-12 mx-auto"
        style={{
          background: "linear-gradient(to bottom, #CBCECE, #77D8EE, #CBCECE)",
        }}
      >
        <h2 className="text-3xl font-bold mb-12 self-start pl-4 mt-8">
          Welcome to Your Beach Office
        </h2>
        <div className="w-full flex justify-center">
  <div className="w-full max-w-md">
    <TherapyRoomCard
      key={beachRoom.id}
      image={beachRoom.image}
      title={beachRoom.title}
      style={beachRoom.style}
      description={beachRoom.description}
      accessibility={beachRoom.accessibility}
      available={beachRoom.available}
      sessionStartTimeEST={beachRoom.sessionStartTimeEST}
      online={beachRoom.online}
      onEnterClick={() => handleEnterClick(beachRoom.id)}
    />
  </div>
</div>

      </div>
      <Footer />
    </div>
  );
}

export default DemoPage;
